// Temporary: the Lone Wolf APIs omit `Vary: Origin`, so a response cached for
// the other Cloud CMA host fails CORS here. Remove once they send it.
const LWOLF_API_HOST = /^(authentication|platform)\.api\.([a-z]+\.)?lwolf\.com$/

type FetchWithMarker = typeof window.fetch & { lwolfApiNoStore?: boolean }

export function installLwolfApiNoStoreFetch() {
  if ((window.fetch as FetchWithMarker).lwolfApiNoStore) return

  const fetch = window.fetch.bind(window)
  const wrapped: FetchWithMarker = (input, init) => {
    const { hostname } = new URL(
      typeof input === 'object' && 'url' in input ? input.url : String(input),
      window.location.href
    )

    return LWOLF_API_HOST.test(hostname)
      ? fetch(input, { ...init, cache: 'no-store' })
      : fetch(input, init)
  }

  wrapped.lwolfApiNoStore = true
  window.fetch = wrapped
}
